import React from "react";

const opcionesOrden = [
    { campo: "precio", label: "Precio" },
    { campo: "reforma_estandar_min", label: "Reforma Estándar" },
    { campo: "reforma_premium_min", label: "Reforma Premium" },
    { campo: "habitaciones", label: "Habitaciones" },
    { campo: "banos", label: "Baños" },
    { campo: "distancia_metros_centro", label: "Distancia al centro" },
];

const SortOptions = ({ orden, ordenDireccion, cambiarOrden }) => {
    return (
        <div>
            <h2 className="text-sm font-medium mb-2 text-gray-700">Ordenar por</h2>
            <div className="flex flex-wrap gap-2">
                {opcionesOrden.map((opt) => (
                    <button
                        key={opt.campo}
                        className={`text-xs px-3 py-1 rounded-full border transition ${
                            orden === opt.campo
                                ? "bg-green-600 text-white"
                                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                        }`}
                        onClick={() => cambiarOrden(opt.campo)}
                    >
                        {opt.label} {orden === opt.campo ? (ordenDireccion === "asc" ? "↑" : "↓") : ""}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SortOptions;
